import { Component, inject } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { CardModule } from 'primeng/card';
import { PanelModule } from 'primeng/panel';
import { AvatarModule } from 'primeng/avatar';

// constants
import { app } from 'config/app.config';
import { Features } from '@sideline/sideline-apps-shared';

// services
import { NavigationService } from '@sideline/sideline-apps-shared';

// components
import { DemoCallToAction } from 'app/layouts/shared/components/demo-call-to-action/demo-call-to-action';

@Component({
  selector: 'app-landing-content',
  templateUrl: './landing-content.html',
  styleUrl: './landing-content.scss',
  standalone: true,
  imports: [
    AvatarModule,
    ButtonModule,
    CardModule,
    DemoCallToAction,
    PanelModule,
],
})
export class LandingContent {

  // component
  appName: string = app.marketing.names.product;
  appDesc: string = 'The cloud platform for managing your operational applications and data. Streamline your workflow and stay organized with our powerful tools.';
  features: typeof Features = Features;

  // services
  private navService = inject(NavigationService);

  // ==========================================================================================================================
  //  actions
  // ==========================================================================================================================

  redirectToMarketing(route: string = '') {
    const url = `https://sideline-apps.com/${route}`;
    window.open(url, '_blank');
  }

  signIn(): void {
    const redirectUrl = window.location.origin + '/dashboard';
    this.navService.signIn(redirectUrl);
  }

}
